import {axiosApi} from './helper'

// Création de compte
export function splashscreen(){
  return axiosApi('splashscreen', {}, 'get')
}

export function maintenance() {
  return axiosApi('maintenance-check', {}, 'get')
}